import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  Inject,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'ut-impersonation-overlay',
  templateUrl: './impersonation-overlay.component.html',
  styleUrls: ['./impersonation-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImpersonationOverlayComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('impersonateFrameDiv') impersonateDiv!: ElementRef<HTMLDivElement>;
  showFrame: boolean = false;
  readonly dismissTimeoutSeconds = 20;
  msg: string;
  user: any;
  private initPromise: Promise<void>;
  private dismissTimeout?: number;

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject('UserService') private UserService: any,
  ) {}

  ngOnInit(): void {
    this.initPromise = this.initializeComponent();
  }

  private async initializeComponent(): Promise<void> {
    try {
      const res = await this.UserService.me();
      if (res && res.data) {
        this.user = res.data;
        if (this.user.platform_impersonate) {
          const roles = this.user.roles || [];
          this.msg = `WARNING: Impersonating User: ${this.user.platform_id}.
            Any changes made are live. Roles: ${this.formatRoles(roles)}`;
          this.showFrame = true;
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error initializing impersonation overlay:', error);
    }
  }

  formatRoles(roles: readonly string[]): string {
    if (!Array.isArray(roles) || roles.length === 0) {
      return 'No roles';
    }
    return roles.join(', ');
  }

  async ngAfterViewInit(): Promise<void> {
    // Wait for initialization to complete before proceeding
    await this.initPromise;

    // Now we can safely access the ViewChild and update the display
    if (this.impersonateDiv) {
      this.impersonateDiv.nativeElement.style.display = this.showFrame ? 'block' : 'none';
      this.cdr.markForCheck();
    }
  }

  ngOnDestroy(): void {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout);
    }
  }

  dismissBanner(): void {
    this.impersonateDiv.nativeElement.style.display = 'none';

    // Clear any existing timeout
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout);
    }

    // Show again after the specified timeout
    this.dismissTimeout = window.setTimeout(() => {
      if (this.showFrame && this.impersonateDiv) {
        this.impersonateDiv.nativeElement.style.display = 'block';
      }
    }, this.dismissTimeoutSeconds * 1000);
  }
}
